import { OrdningsVerdi, PaginatedResult } from './../../../models';
import { getQueryURL } from '../requestService';
import { client } from '../../client';
import { MessageRequiredAnswer } from '../../../models/messageRequiredAnswer';
import { handleError } from '../../../features/layout/layoutSlice';
import { store } from '../../../app/store';
import RequestTreeService from '../requestTreeService';
import { OrdningsVerdiLight } from '../../../models/ordningsVerdiLight';


export default class OrdningsVerdiService extends RequestTreeService<OrdningsVerdi, 'ordningsVerdi'> {
    constructor(serviceName: 'ordningsVerdi') {
        super(serviceName);
        this.idKey = 'uniqueId';
    }
    children = async (parentId: number) => client.get<OrdningsVerdi[]>(getQueryURL(`${this.serviceName}/${parentId}/children`));
    childrenLight = async (parentId: number) => client.get<OrdningsVerdiLight[]>(getQueryURL(`${this.serviceName}/${parentId}/childrenLight`));

    allTreeItems = async (eksternId: string) => client.get<OrdningsVerdi[]>(getQueryURL(`${this.serviceName}/${encodeURIComponent(eksternId)}/allTreeItems`));
    allTreeItemsLight = async (eksternId: string) => client.get<OrdningsVerdiLight[]>(getQueryURL(`${this.serviceName}/${encodeURIComponent(eksternId)}/allTreeItemsLight`));

    ordningsVerdiByOrdningsprinsippUniqueId =
        async (uniqueId: number, searchString: string) =>
            client.get<PaginatedResult<OrdningsVerdiLight>>
                (`${this.serviceName}/${encodeURIComponent(uniqueId)}/ordningsVerdiByOrdningsprinsippUniqueId?q=${encodeURIComponent(searchString)}&disablePagination=true`);

    ordningsVerdiByUniqueId =
        async (ordningsverdiId: string) =>
            client.get<OrdningsVerdi>(`${this.serviceName}/${encodeURIComponent(ordningsverdiId)}/ordningsVerdiByUniqueIdEllerSammensatt`) as unknown as OrdningsVerdi;

    hentOrdningsVerdiLightListe =
        async (searchString: string) =>
            client.get<OrdningsVerdiLight[]>
                (`${this.serviceName}/hentOrdningsverdiLight?q=${encodeURIComponent(searchString)}`);

    hentOrdningsVerdiListe =
        async (searchString: string) =>
            client.get<OrdningsVerdi[]>
                (`${this.serviceName}/hentOrdningsverdiListe?q=${encodeURIComponent(searchString)}`);

    validateFraDato = async (value: OrdningsVerdi) => client.post<boolean>(`${this.serviceName}/ValidateFraDato`, value);
    validateTilDato = async (value: OrdningsVerdi) => client.post<boolean>(`${this.serviceName}/ValidateTilDato`, value);

    import = async (fileContent: Blob, filNavn: string) => {
        try {
            const buffer = await fileContent.arrayBuffer();
            const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/import`, { filNavn }), buffer);
            return { success: true, msg: res.message };
        } catch (err) {
            await store.dispatch(handleError(err as Error));
            return { success: false, msg: (err as Error).message };
        }
    };
    override update(item: OrdningsVerdi) {
        return client.post<OrdningsVerdi>(`${this.serviceName}/${encodeURIComponent(item.uniqueId!)}`, item);
    }
}
